import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Reveal } from '@/components/generals/reveal'

interface SectionHeadingProps {
    id: string
    eyebrow: string
    title: ReactNode
    body?: ReactNode
    align?: 'left' | 'center'
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({ id, eyebrow, title, body, align = 'left', className }) => {
    return (
        <Reveal className={cn(align === 'center' && 'mx-auto text-center', 'max-w-3xl', className)}>
            <p className={cn('flex items-center gap-3 font-mono text-xs font-medium uppercase tracking-[0.22em] text-brand', align === 'center' && 'justify-center')}>
                <span aria-hidden='true' className='h-px w-8 bg-brand/50' />
                {eyebrow}
            </p>
            <h2 id={id} className='mt-5 text-balance font-heading font-expanded text-[clamp(1.9rem,4.4vw,3.4rem)] font-extrabold leading-[1.04] tracking-tight text-white'>
                {title}
            </h2>
            {body && (
                <p className='mt-5 text-pretty text-base leading-relaxed text-white/65 sm:text-lg'>
                    {body}
                </p>
            )}
        </Reveal>
    )
}
